// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".likeshop-header[data-v-2caec8f9]{box-shadow:0 .5px 0 0 var(--border);display:flex;padding:var(--space-16)}", ""]);
// Exports
module.exports = exports;
